import { Grid, Typography } from "@mui/material";
import React from "react";
import { useFormContext } from "react-hook-form";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import { customValidation, validations } from "../../../commonFunctions/CommonFunctions";
import WSTextAreaField from "../../../Components/WSTextArea/WSTextArea";

export const FlightInformation: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();

  return (
      <Grid container  spacing={2}>
        <Grid item xs={12} sm={3}>
          <Typography>Flight No</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("flightno")}
            id="flightno"
            name="flightno"
            control={control}
            rules={{ required: true }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography>Seat No</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("seatno")}
            id="seatno"
            name="seatno"
            control={control}
            rules={{ required: true }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography>Boarding Time</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
          <WSTextField
            label={""}
            {...register("boardingtime")}
            id="boardingtime"
            name="boardingtime"
            control={control}
            rules={{ required: true }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography>Departure Time</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
        <WSTextField
            label={""}
            {...register("departuretime")}
            id="departuretime"
            name="departuretime"
            control={control}
            rules={{ required: true }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography>Boarding Class</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
        <WSTextField
            label={""}
            {...register("boardingclass")}
            id="boardingclass"
            name="boardingclass"
            control={control}
            rules={{ required: true }}
          />
        </Grid><Grid item xs={12} sm={3}>
          <Typography>Sector</Typography>
        </Grid>
        <Grid item xs={12} sm={9}>
        <WSTextField
            label={""}
            {...register("sector")}
            id="sector"
            name="sector"
            control={control}
            rules={{ required: true }}
          />
        </Grid>
        
      </Grid>
  );
});
